export default __webpack_public_path__ + "static/media/americanRouletteTimer.a28042e6.svg";